export default __webpack_public_path__ + "static/media/3.c64b2582.png";